exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-vue[data-v-4699bb41]:focus{outline:0\n}\n.vue-buffer[data-v-4699bb41]{margin-bottom:4rem;width:100%\n}\n.list-enter-active[data-v-4699bb41],.list-leave-active[data-v-4699bb41]{transition:all 1s\n}\n.list-leave-to[data-v-4699bb41],.list-enter[data-v-4699bb41]{opacity:0;transform:translateY(30px)\n}\n.list-enter-to[data-v-4699bb41],.list-leave[data-v-4699bb41]{opacity:1;transform:translateY(0)\n}\na[data-v-4699bb41]:focus{border:1px solid\n}", ""]);

// exports
